<template>
  <div v-loading="loading">
    <el-row class="tac" type="flex">
      <el-col :span="24" class="layout-header">
        <div class="layout-header-logo">
          <img :src="lkdLogo" style="height: 50px;margin-top: 5px">
        </div>
        <span style="margin-right: 150px;color: white">打印预览&nbsp;&nbsp;<i class="el-icon-close" @click="back"
            style="color: white"></i></span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="4" style="margin-top: 20px">
        <h4 style="text-align: center">打印预览</h4>
      </el-col>
      <el-col :span="2" :offset="14" style="margin-top: 20px">
        <i class="el-icon-close" @click="back"></i>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
    <div id="subOutputRank-print" style="margin: auto">
      <template v-for="item in tableData">
        <v-tax :tableData="item" :key="item.ORDER_DETAIL_ID" :headerData="topData" :manager="managername"
          :supplier="printName" :TOTAL_REAL_FEE="TOTAL_REAL_FEE" :TOTAL_PROJECT_PRICE="TOTAL_PROJECT_PRICE" :TOTAL_PROJECT_NEED_PRICE="TOTAL_PROJECT_NEED_PRICE"
               :style="{ whiteSpace: 'nowrap' }"></v-tax>
      </template>
    </div>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { supplierCusNewDetailFun, updateSupplierPrintOrderFun } from 'api/sellOrder';
import VTax from '@/components/orderPrint/supplierCusOrderTax';

export default {
  data() {
    return {
      showStatus: null,
      loading: true,
      managername: sessionStorage.getItem('name'),
      tableData: [],
      topData: [],
      printName: sessionStorage.getItem('supplierName'),
      currentOrderFlag: sessionStorage.getItem('currentOrderFlag'),
      lkdLogo: this.$util.publicLogo() || '',
      TOTAL_REAL_FEE: 0,
      TOTAL_PROJECT_PRICE: 0,
      TOTAL_PROJECT_NEED_PRICE: 0,
    };
  },
  components: {
    VTax,
  },
  created() {
    this.queryOrderDetailListData();
  },
  methods: {
    back() {
      window.history.back(-1);
      sessionStorage.removeItem('payableName');
      sessionStorage.removeItem('supplierName');
    },
    queryOrderDetailListData() {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      supplierCusNewDetailFun(params)
        .then((result) => {
          if (result[0].TITLE[0].AGENT) {
            sessionStorage.setItem('AGENT', result[0].TITLE[0].AGENT);
          } else {
            sessionStorage.setItem('AGENT', 0);
          }
          this.showStatus = result[0].TITLE[0].STATUS;
          console.log(this.showStatus);
          const res = result.length > 0 ? result[0].DETAIL : [];
          for (let i = 0; i < res.length; i++) {
            res.forEach((item, index) => {
              item.ID = index + 1;
            });
          }
          if (res.length > 0) {
            res.forEach((val) => {
              this.TOTAL_REAL_FEE += Number(val.REAL_FEE);
              this.TOTAL_PROJECT_PRICE += Number(val.PROJECT_TOTAL_FEE);
              this.TOTAL_PROJECT_NEED_PRICE += Math.round((Number(val.NEED_COUNT) * Number(val.PROJECT_PRICE)) * 100) / 100;
            });
          }
          this.topData.push(...result[0].TITLE);
          this.topData[0].ORDER_ID = sessionStorage.getItem('orderId');
          this.loading = false;
          const len = res.length;
          const n = 30; // 假设每行显示4个
          const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1);
          const data = [];
          for (let i = 0; i < lineNum; i++) {
            const temp = res.slice(i * n, i * n + n);
            data.push(temp);
            data.forEach((item, index) => {
              item.currentPage = index + 1;
              item.totalPage = lineNum;
            });
            this.tableData = data;
            if (sessionStorage.getItem('realCountFlag') == 0) this.tableData[0].forEach((item) => item.REAL_COUNT = '');
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    printPreview() {
      console.log(this.currentOrderFlag);
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('orderId')),
          };
          if (this.currentOrderFlag == 1 && this.showStatus == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
            updateSupplierPrintOrderFun(params)
              .then((result) => {
                this.$router.push({ name: 'NewOrderList' });
                this.$message.show({ text: '操作成功', type: 'success' });
                const subOutputRankPrint = document.getElementById('subOutputRank-print');
                const newContent = subOutputRankPrint.innerHTML;
                const oldContent = document.body.innerHTML;
                document.body.innerHTML = newContent;
                window.print();
                window.location.reload();
                document.body.innerHTML = oldContent;
                document.body.style.cursor = 'default';
                return false;
              }).catch((error) => {
                this.$message.show({ text: error, type: 'error' });
                document.body.style.cursor = 'default';
              });
          } else {
            const subOutputRankPrint = document.getElementById('subOutputRank-print');
            const newContent = subOutputRankPrint.innerHTML;
            const oldContent = document.body.innerHTML;
            document.body.innerHTML = newContent;
            window.print();
            window.location.reload();
            document.body.innerHTML = oldContent;
            document.body.style.cursor = 'default';
          }
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
};
</script>
<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

#subOutputRank-print {
  width: 284mm;
}

@media print {
  .page-break {
    page-break-after: always;
  }
}

.layout-header {
  z-index: 10;
  position: fixed;
  width: 100%;
  background: linear-gradient(#373737, #464c5b);
  line-height: 60px;
  text-align: right;
  border-bottom: 1px solid #505664;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.layout-header-logo {
  height: 60px;
  width: 210px;
  float: left;
}

.layout-header-logo img {
  width: 90%;
  margin-right: 5%;
  height: 60px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/orderPrint/supplierCusOrderPrint.vue